var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "spa-soft__masthead masthead component small " },
    [
      _c("div", { staticClass: "masthead-wrapper" }, [
        _c("div", { staticClass: "masthead-image" }, [
          _c(
            "picture",
            {
              directives: [
                {
                  name: "lazyload",
                  rawName: "v-lazyload",
                  value: {
                    src: _vm.propertyData.imageSrc,
                    set: [
                      { width: "1600", height: "900", breakpoint: "xs" },
                      { width: "2400", height: "1350", breakpoint: "xl" },
                    ],
                    fit: "crop",
                    align: "center",
                  },
                  expression:
                    "{ src: propertyData.imageSrc,\n                      set: [\n                        { width: '1600', height: '900', breakpoint: 'xs' },\n                        { width: '2400', height: '1350', breakpoint: 'xl' },\n                      ],\n                      fit: 'crop',\n                      align: 'center'\n        }",
                },
              ],
              staticClass: "image-wrapper",
            },
            [
              _c("img", {
                staticClass: "image",
                attrs: {
                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                  alt: _vm.propertyData.imageAlt,
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "masthead-content container" }, [
          _c("h1", { staticClass: "masthead-title" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.propertyData.facilityName) + "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "masthead-description container" }, [
        _c("div", { staticClass: "masthead-description-text" }, [
          _vm._v("\n      " + _vm._s(_vm.propertyData.description) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "masthead-contact-info" }, [
          _vm.propertyData.email
            ? _c("div", { staticClass: "masthead-contact-info-item email" }, [
                _c("span", { staticClass: "icon-mail-gold icon" }),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.propertyData.email } },
                  [_vm._v(_vm._s(_vm.propertyData.email))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.propertyData.phone
            ? _c("div", { staticClass: "masthead-contact-info-item phone" }, [
                _c("span", { staticClass: "icon-phone-gold icon" }),
                _vm._v(" "),
                _c("a", { attrs: { href: "tel:" + _vm.propertyData.phone } }, [
                  _vm._v(_vm._s(_vm.propertyData.phone)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.propertyData.openingHours
            ? _c(
                "div",
                { staticClass: "masthead-contact-info-item opening-hours" },
                [
                  _c("em", { staticClass: "icon-clock-gold icon" }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "opening-hours-list",
                      attrs: {
                        "aria-label": _vm.tc("spaSoft.step1.openHoursLabel"),
                      },
                    },
                    _vm._l(
                      _vm.propertyData.openingHours,
                      function (openingHour, index) {
                        return _c(
                          "li",
                          {
                            key: "opening-" + index,
                            staticClass: "opening-hours-range",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(openingHour.value) +
                                "\n          "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "masthead-content" }, [
      _c("div", { staticClass: "masthead-content__wrapper" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }